import React, { useContext } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { SpaceBetween } from 'styles/GlobalStyle';
import { AssessmentDistributionStyles } from './Style';
import { RatingList } from 'components/Rating';
import { ReportContext } from './ReportContext';
import { ratingHooks } from '.';
import { getChartOptions } from './distributionChartOptions';
import FilterManager from 'components/FilterManager';

ChartJS.register(LineElement, PointElement, LinearScale, TimeScale, Tooltip, Legend);

const filterSchema = {
    primary: [
        { key: "school_year", overrides: { multiple: true, hideClear: true } }
    ]
};

const AssessementDistribution = ({ graph, percent }) => {
    // 1. ניהול הסטייט הגלובלי (פילטרים)
    const { distributionFilters, setDistributionFilters } = useContext(ReportContext);

    // 2. הפעלת הלוגיקה לעיבוד הנתונים
    const { datasets, semesters } = ratingHooks.useDistributionGraphData(graph, distributionFilters);

    // 3. בניית הגדרות הגרף
    const options = getChartOptions(semesters, percent);

    // תנאי שבודק האם הנתונים מהשרת כבר קיימים ומוכנים
    const isDataReady = graph && graph.ratings_thresholds && graph.student_assessments;

    return (
        <AssessmentDistributionStyles>
            <FilterManager
                schema={filterSchema}
                values={distributionFilters}
                onChange={setDistributionFilters}
            />
            <div className='graph-and-legend'>
                <div className='distribution-content'>
                    {!isDataReady ? (
                        <div className='loading'>
                            <span>טוען נתונים...</span>
                        </div>
                    ) : (
                        <Line
                            responsive={true}
                            data={{ datasets }}
                            options={options}
                        />
                    )}
                </div>
                <SpaceBetween />
                <div className='rating-list'>
                    <RatingList title="ביצועי התלמיד" />
                </div>
            </div>
        </AssessmentDistributionStyles>
    );
};

export default AssessementDistribution;